import { fileName } from 'Regex';

export const files = async () => {
  const files = document.querySelectorAll('button[data-required="true"]');
  if (!files) return true;

  let filesDup: Element[] = [...Array.from(files)];
  for (let i = 0; i < files.length; i++) {
    const requiredWith = JSON.parse(
      files[i].getAttribute('data-required-with') || '[]'
    );
    for (let j = 0; j < requiredWith.length; j++) {
      const requiredWithElement = document.querySelector(
        `button[data-id="${requiredWith[j]}"]`
      );

      if (
        requiredWithElement &&
        requiredWithElement.getAttribute('data-required') === 'false'
      ) {
        filesDup = filesDup.filter(
          (file) =>
            file.getAttribute('data-id') !== files[i].getAttribute('data-id')
        );
      }
    }
  }

  if (filesDup.length) {
    const btn = filesDup[0] as HTMLButtonElement;

    if (btn) {
      btn.setAttribute('aria-invalid', 'true');

      let span = btn.nextElementSibling as HTMLSpanElement;
      if (!span || span.innerText !== 'שדה חובה') {
        span = document.createElement('span');
        span.innerText = 'שדה חובה';
        if (btn) {
          btn.insertBefore(span, btn.nextSibling);
        }
      }
      span.style.display = 'flex';
      span.style.flexDirection = 'column';
      span.style.fontSize = '14px';
      span.style.color = '#d90000';
      span.style.position = 'absolute';
      span.style.bottom = '-25px';

      btn.style.color = '#d90000';
      btn.style.borderColor = '#d90000';
      btn.focus();
      return false;
    }
  }
  return true;
};

export const getCleanFileName = (name: string) => {
  const extensionIndex = name?.lastIndexOf('.');
  const cleanPart =
    name?.slice(0, extensionIndex).replaceAll(fileName, '') ||
    'Filename_' + new Date().getTime().toString()?.slice(0, -3);
  const cleanName =
    cleanPart + '.' + name?.slice(extensionIndex).replaceAll(fileName, '');

  return cleanName;
};
